import { c as _c } from "react/compiler-runtime";
import { formatPrice, ProductPriceDisplay } from '@libs/common-next';
import { type BuyItAgainItem } from '@libs/common-types';
export const Price = t0 => {
  const $ = _c(18);
  const {
    price
  } = t0;
  let t1;
  if ($[0] !== price.saleValidUntil) {
    t1 = price.saleValidUntil && new Date(price.saleValidUntil) >= new Date();
    $[0] = price.saleValidUntil;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isOnSale = Boolean(t1);
  if (price.type === "range") {
    const displayPrice = isOnSale && price.sale ? price.sale : price.original;
    let t2;
    if ($[2] !== displayPrice.from) {
      t2 = formatPrice(displayPrice.from);
      $[2] = displayPrice.from;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    const t3 = isOnSale && Boolean(price.sale);
    let t4;
    if ($[4] !== displayPrice.to) {
      t4 = formatPrice(displayPrice.to);
      $[4] = displayPrice.to;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    if ($[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
      t5 = <ProductPriceDisplay fromPrice={t2} isOnSale={t3} toPrice={t4} type="range" />;
      $[6] = t2;
      $[7] = t3;
      $[8] = t4;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    return t5;
  }
  const salePrice = isOnSale ? price.sale : undefined;
  let t2;
  if ($[10] !== price.original || $[11] !== salePrice) {
    t2 = salePrice ? formatPrice(price.original) : undefined;
    $[10] = price.original;
    $[11] = salePrice;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  const t3 = salePrice ?? price.original;
  let t4;
  if ($[13] !== t3) {
    t4 = formatPrice(t3);
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t2 || $[16] !== t4) {
    t5 = <ProductPriceDisplay originalPrice={t2} price={t4} type="default" />;
    $[15] = t2;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
};